/* istanbul ignore file */
export var DirectDebitInfo;
(function (DirectDebitInfo) {
    DirectDebitInfo["HARDREFUSED"] = "HARDREFUSED";
    DirectDebitInfo["SOFTREFUSED"] = "SOFTREFUSED";
    DirectDebitInfo["ONGOING"] = "ONGOING";
    DirectDebitInfo["MANUAL"] = "MANUAL";
})(DirectDebitInfo || (DirectDebitInfo = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["ONGOING_PAYMENT"] = "ONGOING_PAYMENT";
    PaymentStatus["OPEN"] = "OPEN";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["OVERDUE"] = "OVERDUE";
    PaymentStatus["NOT_REFUNDED"] = "NOT_REFUNDED";
    PaymentStatus["REFUNDED"] = "REFUNDED";
    PaymentStatus["INSTALMENT"] = "INSTALMENT";
})(PaymentStatus || (PaymentStatus = {}));
